module.exports = __webpack_public_path__ + "img/ball_9_orange.4ce24211.png";